import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FormGroup, Label } from 'reactstrap';
import * as Icon from 'react-feather';
import { parse, isValid } from 'date-fns';

const FormDateInput = ({
  className = '',
  inputClassName = '',
  label,
  name,
  value,
  placeholder,
  disabled,
  isShowLabel = true,
  touched,
  errors,
  onChange,
  onFocus,
  onBlur,
  showTimeSelect = false,
  dateFormat = 'dd/MM/yyyy',
  maxDate = undefined,
  minDate = undefined,
  showTimeSelectOnly = false,
  timeIntervals = '60',
  timeFormat = undefined,
  minTime = undefined,
  maxTime = undefined
}) => {
  const isError = touched && errors && touched[name] && errors[name];

  const parseDate = (dateValue) => {
    if (dateValue instanceof Date) return dateValue;
    const formats = [
      'dd-MM-yyyy',
      'dd/MM/yyyy',
      'yyyy/MM/dd',
      'yyyy-MM-dd',
      'yyyy-dd-MM',
      'yyyy/dd/MM'
    ];

    let parsedDate;
    for (const formatString of formats) {
      parsedDate = parse(dateValue, formatString, new Date());
      if (isValid(parsedDate)) {
        return parsedDate;
      }
    }
    return new Date();
  };

  // Handle date change and ensure proper parsing and formatting
  const handleDateChange = (date) => {
    if (onChange) {
      if (showTimeSelectOnly && date) {
        const newDate = new Date();
        if (dateFormat === 'HH:mm') {
          newDate.setHours(date.getHours());
          newDate.setMinutes(date.getMinutes());
          newDate.setSeconds(0);
        } else {
          newDate.setHours(date.getHours());
          newDate.setMinutes(date.getMinutes());
          newDate.setSeconds(date.getSeconds());
        }

        onChange({ target: { name, value: newDate } });
      } else {
        onChange({ target: { name, value: date } });
      }
    }
  };

  return (
    <FormGroup className={className}>
      {isShowLabel && (
        <Label htmlFor={name} className="w-100">
          {label}
        </Label>
      )}
      <div className="date-input-group">
        <DatePicker
          showTimeSelect={showTimeSelect}
          className={`form-control ${isError ? 'is-invalid' : ''} ${inputClassName}`}
          selected={value ? parseDate(value) : ''}
          onChange={handleDateChange}
          onFocus={onFocus}
          onBlur={onBlur}
          placeholderText={placeholder}
          disabled={disabled}
          dateFormat={showTimeSelectOnly ? (timeFormat ? timeFormat : 'HH:mm:ss') : dateFormat}
          allowSameDay
          maxDate={maxDate}
          minDate={minDate}
          timeIntervals={timeIntervals}
          timeFormat="HH:mm"
          showTimeSelectOnly={showTimeSelectOnly}
          showPopperArrow={false}
          maxTime={maxTime}
          minTime={minTime}
        />
        <span className="input-icon">
          <Icon.Calendar size={16} />
        </span>
      </div>
      {isError && <span className="invalid-feedback">{errors[name]}</span>}
    </FormGroup>
  );
};

FormDateInput.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.instanceOf(Date),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isShowLabel: PropTypes.bool,
  touched: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
  maxTime: PropTypes.any,
  minTime: PropTypes.any,
  showTimeSelect: PropTypes.bool,
  showTimeSelectOnly: PropTypes.bool,
  dateFormat: PropTypes.string,
  timeIntervals: PropTypes.string,
  timeFormat: PropTypes.string
};

export default FormDateInput;
